/*
 *
 * ExportPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 07-Nov-2024
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { doPopup } from 'Store/actions/popup'
import * as OrderManagementActions from 'Route/OrderManagement/modules/OrderManagementActions'
import * as OperationManagementActions from 'Store/actions/operations'
import * as PblManagementActions from 'Store/actions/pblManagement'
import * as formikActions from 'Store/actions/formik'
import ExportPopUp from './ExportPopUp'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(OrderManagementActions, dispatch),
  ...bindActionCreators(OperationManagementActions, dispatch),
  ...bindActionCreators(PblManagementActions, dispatch),
  ...bindActionCreators(formikActions, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => {
  let route = 'OrderFilterForm'
  if (/operationmanagement/i.test(window.location.pathname)) {
    route = 'OperationFilterForm'
  } else if (/pblmanagement/i.test(window.location.pathname)) {
    route = 'pblManagementForm'
  }

  return {
    reserchFromDate: state?.formik?.formikForm[route]?.fromTime || '',
    reserchToDate: state?.formik?.formikForm[route]?.toTime || '',
    reserchFromTime: state?.formik?.formikForm[route]?.hourMinutesFromTime || '',
    reserchToTime: state?.formik?.formikForm[route]?.hourMinutesToTime || '',
    isLoading:
      state.loading?.local_exportOrders ||
      state.loading?.local_exportOperations ||
      state.loading?.local_exportPbls ||
      false,
    isOperation: route === 'OperationFilterForm',
    isPbl: route === 'pblManagementForm'
  }
}

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ExportPopUp)
